import * as React from "react";
import { Typography, Container, Grid, Button } from "@material-ui/core";
import { RouteComponentProps } from "react-router";
import { SellDirectToBidderComponent } from "../components/ended-auctions/SellDirectToBidderComponent";
import { SecureArea } from "../components/authentication/SecureArea";
import { MemberPermission } from "../services/MemberService";
import { withAITracking } from "@microsoft/applicationinsights-react-js";
import { reactPlugin } from "../services/TelemetryService";

type TParams = { auctionId: string };

function SellDirectToBidder({ match }: RouteComponentProps<TParams>) {
  const [showSellToNewBidder, setShowSellToNewBidder] = React.useState<boolean>(false);

  return (
    <Container maxWidth={"lg"} fixed>
      <SecureArea memberPermission={MemberPermission.BucketAdmin}>
        <Grid container justify="space-between">
          <Grid item xs={6}>
            <Typography variant="h4" color="primary">
              Sell Direct to Bidder
            </Typography>
          </Grid>

          <Grid container item justify="flex-end" xs={6}>
            <Button variant="outlined" color="primary" onClick={() => setShowSellToNewBidder(true)}>
              Sell To New Bidder
            </Button>
          </Grid>
        </Grid>

        <Typography variant="subtitle1" gutterBottom style={{ paddingTop: '1rem' }}>
          This page shows the bid history and the relevant contact information for the bidders for the auction.
        </Typography>

        <SellDirectToBidderComponent auctionId={match.params.auctionId} showSellToNewBidder={showSellToNewBidder} setShowSellToNewBidder={setShowSellToNewBidder} />
      </SecureArea>
    </Container>
  );
}

export default withAITracking(reactPlugin, SellDirectToBidder, "SellDirectToBidder");
